<div class="d-flex w-full">
  <relationship-options-button
    [disabled]="hasViewOnlyRole"
    [relatedItem]="relatedItem"
    (updateOption)="onUpdateLinkOption($event)"
    data-test-id="relationship-option-button"></relationship-options-button>
  <div class="hover-area align-items-c d-flex row-direction w-full" #rowInfo (keydown)="onKeydown($event)" tabindex="0">
    <div class="node-icon">
      <i class="fs-20px sp-mr-5" [uiTooltipTitle]="tooltipTitle | localize" [uiType]="relatedItem.iconType" ui-icon ui-tooltip uiTheme="fill"></i>
    </div>
    <div
      class="node-title"
      id="related-item"
      [attr.aria-describedby]="'related-item-row-' + relatedItem.id"
      (click)="openRelatedItem(relatedItem)"
      data-test-id="related-item-title"
      ui-typography
      uiEllipsis>
      {{ relatedItem.name }}
    </div>
    <!-- The div below plays the role of aria-description since it still doesn't have full support for macOs and safari -->
    <!-- Once we have full support we can simply replace it with aria-description -->
    <div class="related-item-row-description" [attr.id]="'related-item-row-' + relatedItem.id">{{ "backspace_delete_related_item" | localize }}</div>
    <div class="rest-nodes">
      <ui-assignee-avatar-group class="sp-mr-5" *ngIf="relatedItem.ownerIds" [uiMax]="2" [uiAlignRight]="true" uiSize="sm">
        <ui-assignee-avatar *ngFor="let assigneeId of relatedItem.ownerIds" [fromAssigneeId]="assigneeId" />
      </ui-assignee-avatar-group>
      <div class="trash-bin-icon-wrapper" *ngIf="!hasViewOnlyRole" [uiTooltipTitle]="'remove' | localize" (click)="onDeleteItem()" ui-tooltip>
        <i class="trash-bin-icon" ui-icon uiType="trash-bin"></i>
      </div>
    </div>
  </div>
</div>
